import { BzkndModel } from "app/model/common/bzkndModel";


export class UserMemberModel {

  emksMbrsClCd?: string;

  mktgJoinAgreYn?: string
  emksRe100JoinClCd?: string;
  userId?: string;

  userPwdEncVal?: string;
  conFirmPw?: string;

  bizrRegNo?: string
  comRegNumFi?: string;
  comRegNumSe?: string;
  comRegNumTh?: string;

  bizrNm?: string;
  reprNm?: string;

  coRepNo?: string
  repNum1?: number;
  repNum2?: number;
  repNum3?: number;

  bizrAddr?: string;
  bizrDtlsAddr?: string;

  tchgrNm?: string;

  tchgrCplcNo?: string;
  conPerChar1?: number;
  conPerChar2?: number;
  conPerChar3?: number;

  tchgrEmailAddr?: string;

  emksEntClCd?: string;

  staIndClaCerId?: string;
  staIndClaCer1?: string;
  staIndClaCer2?: string;
  bzknds?: any[]; // 임시저장 데이터 불러올때 사용

  attBusRegCer?: any;
  userTmpSavYn?: string;
  opbizYmd?: string;

  deleteFile?: any[];
  custRegRqss?: any;

  // 사업자등록증 파일
  file?: any;
  fileResponses?: any;
  fileInfos?: any;
  repAtflId?: string;
  isExistFileDelete?: boolean;

  // 로고 파일
  logo?: any;
  logoPreview?: any;
  coLogoAtflId?: string;
  isExistLogoFileDelete?: boolean;

  // 인감 파일
  ofcsl?: any;
  ofcslPreview?: any;
  coOfcslAtflId?: string;
  isExistOfcslFileDelete?: boolean;

  custRegRqsRsrcs?: any;

  // 그 외
  eltrSgntCtt?: any;
  userCoNm?: any;
  userCoAddr?: any;
  userCoDtlsAddr?: any;
  bizrRegcAtflId?: any;
  bizrRegcAtflNm?: any;
  aprYn?: any;
  aprDt?: any;
  useYn?: any;

  // 한전 정보 목록
  userKepcoCustInfos?: any;
  custRegRqsRequests?: any;

  // 사업자번호, 이메일 진위여부 확인 필요 여부. true인 경우 확인 완료.
  isModifyRegNo?: boolean;
  isModifyEmail?: boolean;

  // 사용자인 경우 이메일
  tchgrEmailAddr1?: any;
  tchgrEmailAddr2?: any;

  // 사용자 권한ID 배열
  authIds?: string[];

  // 한전 MG 사용자 수정 결과 메시지
  custRegRqsStatus?: any;

  // 바로빌 아이디
  barobillId?: string;
}

export interface BaseUserSignUp {
  emksMbrsClCd?: string // 회원구분코드 ( 1=산단기업, 2=중개업자, 3=장외거래)
  mktgJoinAgreYn?: 'Y' | 'N' // 마케팅 참여 동의 여부

  // ## 산단기업 전용
  emksRe100JoinClCd?: string; // RE100 참여여부
  emksEntClCd?: string; // 기업 구분
  bzknd?: Omit<BzkndModel, 'crbnEmsnCoefIndsClCds'>; // 업종 구분

  // ## 공통
  // 로그인 정보
  userId?: string;
  userPwdEncVal?: string;
  conFirmPw?: string;

  // 기본정보 입력
  bizrNm?: string; // 회사명

  bizrRegNo?: string; // 사업자 등록번호
  comRegNumFi?: string;
  comRegNumSe?: string;
  comRegNumTh?: string;

  coRepNo?: string; // 대표번호
  repNumFi?: string;
  repNumSe?: string;
  repNumTh?: string;

  bizrAddr?: string; // 회사 주소
  bizrDtlsAddr?: string; // 회사 나머지 주소

  tchgrNm?: string; // 담당자명

  tchgrCplcNo?: string; // 담당자 연락처 번호
  tchgrCplcFi?: string;
  tchgrCplcSe?: string;
  tchgrCplcTh?: string;

  tchgrEmailAddr?: string; // 담당자 이메일 주소
  emailPrefix?: string;
  emailSuffix?: string;
}

export class UserKepcoCheckModel {
  kepcoCustNo? : string;
  bizrNm?: string;
}